import "./CustomQuickActionRun.css";
import UploadFiles from "./UploadFiles";
import WriteOrPaste from "./WriteOrPaste";
import { BASEURL } from "../../../../config";
import { CiCircleInfo } from "react-icons/ci";
import React, { useEffect, useState } from "react";
import { Card, Switch, Tooltip, Button } from "antd";
import authAxios from "../../../../Config/AuthAxios";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../../Components/Loader/Loader";
import { useNavigate, useParams } from "react-router-dom";
import { RiEditBoxFill, RiFileUploadFill } from "react-icons/ri";
import { MdKeyboardBackspace, MdInfoOutline } from "react-icons/md";

const CustomQuickActionRun = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const preBuiltSvg = "/assets/prebuilit_icon.svg";
  const [accessLevel, setAccessLevel] = useState("");
  const [pageLoader, setPageLoader] = useState(false);
  const [showOutput, setShowOutput] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [DragDropfile, setDragDropfile] = useState("");
  const [runStatusMainData, setRunStatusMainData] = useState("");
  const [datauploadComputer, setUploadComputerData] = useState([]);
  const [isActionBtnDisabled, setIsActionBtnDisabled] = useState(true);
  const [isUploadOutComputer, setIsUploadOutComputer] = useState(false);
  const quickrunStatusData = useSelector(
    (state) =>
      state?.quick_Action_Run_Status_Data?.quick_Action_Run_Status_data?.data
  );

  // for write or paste
  const [isOpenWitreOrPasteDrawer, setIsOpenWitreOrPasteDrawer] =
    useState(false);

  const buildQuickActionDetaills = useSelector(
    (state) =>
      state?.build_Quick_Action_By_Id_data?.build_quick_action_by_id__data?.data
  );

  const handleGoBackRun = () => {
    Navigate(-1);
  };

  const handleAccessLevelChange = (newValue) => {
    setAccessLevel(newValue ? "ON" : "OFF");
  };

  const tooltipContent = (
    <div className="remove-tooltip-space">
      <p>
        The output will only be visible to you. Account and workspace members
        will not see the output.
      </p>
    </div>
  );

  const handleDragEnter = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    setIsDragging(false);
    const droppedFiles = Array.from(e.dataTransfer.files);
    if (files.length > 0) {
      setDragDropfile((prevFiles) => [...prevFiles, ...droppedFiles]);
      setIsUploadOutComputer(true);
    }
  };

  const handleUploadComputer = () => {
    setIsUploadOutComputer(true);
  };

  const handleWriteOrPasteData = () => {
    setIsOpenWitreOrPasteDrawer(true);
  };

  const setBackToWindow = () => {
    setIsUploadOutComputer(false);
    setUploadComputerData([]);
    setDragDropfile("");
    setRunStatusMainData("");
    setShowOutput(false);
  };

  useEffect(() => {
    if (datauploadComputer.length > 0) {
      setIsActionBtnDisabled(false);
    } else {
      setIsActionBtnDisabled(true);
    }
  }, [datauploadComputer]);

  const handleActionClickApi = async () => {
    let customQaInputIds = datauploadComputer.map((item) => item.file_id);

    let request = {
      is_private: accessLevel === "ON" ? true : false,
      custom_q_a_run_input_ids: customQaInputIds,
    };

    setPageLoader(true);
    const token = localStorage.getItem("token");
    const res = await authAxios({
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
      method: "POST",
      url: BASEURL + `quick-action/${params?.id}/custom-qa-run`,
      data: request,
    });

    if (res?.status === 200) {
      if (res?.data?.data?.status === "PROCESSING") {
        handleProcessingData(res?.data?.data?.id);
      } else if (res?.data?.data?.status === "SUCCESS") {
        handleSuccessData(res);
      } else if (res?.data?.data?.status === "FAILED") {
        handleFailedData(res?.data?.data?.id);
      }
    } else {
      console.log(res);
    }
  };

  const handleProcessingData = async (id) => {
    setPageLoader(true);
    const token = localStorage.getItem("token");
    const res = await authAxios({
      headers: {
        Authorization: `Bearer ${token}`,
      },
      method: "GET",
      url: BASEURL + `quick-action/${params?.id}/run/status/${id}`,
    });

    if (res?.status === 200) {
      if (res?.data?.data?.status === "PROCESSING") {
        setTimeout(() => {
          handleProcessingData(id);
        }, 3000);
      } else if (res?.data?.data?.status === "SUCCESS") {
        handleSuccessData(res);
        setPageLoader(false);
      } else if (res?.data?.data?.status === "FAILED") {
        handleFailedData(res);
        setPageLoader(false);
      }
    }
  };

  const handleSuccessData = async (res) => {
    setRunStatusMainData(res?.data?.data);
    setShowOutput(true);
  };

  const handleFailedData = async (res) => {
    setRunStatusMainData(res?.data?.data);
    setShowOutput(true);
  };

  useEffect(() => {
    if (showOutput === false) {
      setIsUploadOutComputer(false);
      setUploadComputerData([]);
      setDragDropfile("");
      setRunStatusMainData("");
      setShowOutput(false);
    }
  }, [showOutput]);

  useEffect(() => {
    if (quickrunStatusData !== undefined) {
      setRunStatusMainData(quickrunStatusData);
    }
  }, [quickrunStatusData]);

  return (
    <>
      {pageLoader && <Loader />}
      <div className="run-quickaction-main">
        <div className="text-back">
          <h2>{buildQuickActionDetaills?.name}</h2>
          <div onClick={handleGoBackRun}>
            <MdKeyboardBackspace />
            Back
          </div>
        </div>
        <div className="run-quickaction-container">
          <div>
            <Card
              className="run-quickaction_1"
              style={{ height: "fit-content" }}
            >
              <div>
                <button
                  className="pre-built-btn"
                  style={{
                    marginBottom: "20px",
                    padding: "5px 10px",
                    gap: "10px",
                    fontSize: "14px",
                  }}
                >
                  <img src={preBuiltSvg} alt="" />
                  Pre-built QuickAction
                </button>
              </div>
              <div style={{ display: "grid" }}>
                {(buildQuickActionDetaills?.folder_logo_url ||
                  buildQuickActionDetaills?.folder_created_by_name) && (
                  <span>Created by</span>
                )}
                {buildQuickActionDetaills?.folder_logo_url ? (
                  <>
                    <span
                      style={{
                        fontWeight: "600",
                        marginTop: "15px",
                      }}
                    >
                      <Tooltip
                        title={buildQuickActionDetaills?.folder_created_by_name}
                        placement="right"
                      >
                        <img
                          src={buildQuickActionDetaills?.folder_logo_url}
                          alt="logo"
                          style={{
                            width: "20px",
                            height: "20px",
                            borderRadius: "50%",
                            margin: "0 5px",
                          }}
                        />
                      </Tooltip>
                    </span>
                  </>
                ) : (
                  <>
                    <span
                      style={{
                        fontWeight: "600",
                        marginTop: "15px",
                      }}
                    >
                      {buildQuickActionDetaills?.folder_created_by_name}{" "}
                    </span>
                  </>
                )}
                <span style={{ marginTop: "15px" }}>
                  This QuickAction has been created by{" "}
                  {buildQuickActionDetaills?.folder_created_by_name}. Please
                  review the instructions below to execute the QuickAction
                  effectively.
                </span>
              </div>
            </Card>
            {buildQuickActionDetaills?.description && (
              <Card
                className="run-quickaction_1"
                style={{ height: "fit-content" }}
              >
                <div>
                  <h4 style={{ marginTop: 0 }}>Description</h4>
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: buildQuickActionDetaills?.description,
                  }}
                />
              </Card>
            )}
          </div>

          <Card className="run-quickaction_2">
            <div className="drag-zone-width">
              <div className="switch-toggle-upper">
                <h3>Input data</h3>
                <div>
                  <Switch
                    size="large"
                    className="switch-large"
                    checked={accessLevel === "ON"}
                    onChange={handleAccessLevelChange}
                  />
                  <Tooltip
                    placement="top"
                    title={tooltipContent}
                    overlayStyle={{
                      maxWidth: "900px",
                    }}
                  >
                    <span style={{ marginRight: "4px" }}>Private</span>
                    <MdInfoOutline />
                  </Tooltip>
                </div>
              </div>
              {isUploadOutComputer ||
              DragDropfile ||
              datauploadComputer.length > 0 ? (
                <UploadFiles
                  back={setIsUploadOutComputer}
                  isUploadOutComputer={isUploadOutComputer}
                  pageLoader={pageLoader}
                  setPageLoader={setPageLoader}
                  setBack={setBackToWindow}
                  datauploadComputer={datauploadComputer}
                  setUploadComputerData={setUploadComputerData}
                  DragDropfile={DragDropfile}
                  setDragDropfile={setDragDropfile}
                  isOpenWitreOrPasteDrawer={isOpenWitreOrPasteDrawer}
                  setIsOpenWitreOrPasteDrawer={setIsOpenWitreOrPasteDrawer}
                  handleWriteOrPasteData={handleWriteOrPasteData}
                  setAccessLevel={setAccessLevel}
                  quickrunStatusData={runStatusMainData}
                  setRunStatusMainData={setRunStatusMainData}
                  showOutput={showOutput}
                  setShowOutput={setShowOutput}
                />
              ) : (
                <div
                  className={`drag-drop-field supporting-document-out-2 ${
                    isDragging ? "dragging" : ""
                  }`}
                  onDragEnter={handleDragEnter}
                  onDragLeave={handleDragLeave}
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                >
                  <div className="drag-zone">
                    {/* <h3>Input data</h3> */}
                    <div className="supporting-document-out-upload-img-height-320">
                      <div className="supporting-document-out-upload-main-div">
                        <div className="supporting-document-out-upload-span">
                          <div
                            className="supporting-document-out-upload-sub-div"
                            style={{
                              textAlign: "-webkit-center",
                            }}
                          >
                            <div
                              className="supporting-document-out-upload-middle-div-first-p run-quick-uploadtype"
                              style={{
                                width: "60%",
                              }}
                            >
                              {
                                "Drag and drop multiple files, or click to upload multiple files (PDFs, DOCX, DOC or TXT)"
                              }
                            </div>
                            <div className="supporting-document-out-upload-middle-div-second-p">
                              Or
                            </div>
                            <div className="supporting-document-out-upload-middle-div-tree-p">
                              <div
                                className="supporting-document-out-image-button"
                                onClick={handleUploadComputer}
                              >
                                <RiFileUploadFill className="supporting-document-out-sideIcon-size supporting-document-out-color-text" />
                                Upload Files
                              </div>
                            </div>
                            <div className="supporting-document-out-upload-middle-div-tree-p">
                              <div
                                className="supporting-document-out-image-button"
                                onClick={handleWriteOrPasteData}
                              >
                                <RiEditBoxFill className="supporting-document-out-sideIcon-size supporting-document-out-color-text" />
                                Write or Paste Text
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {!showOutput && (
              <Button
                className="main-api action-btn"
                disabled={isActionBtnDisabled}
                onClick={handleActionClickApi}
              >
                Action
              </Button>
            )}
          </Card>
        </div>
      </div>

      {isOpenWitreOrPasteDrawer && (
        <WriteOrPaste
          isOpenWitreOrPasteDrawer={isOpenWitreOrPasteDrawer}
          setIsOpenWitreOrPasteDrawer={setIsOpenWitreOrPasteDrawer}
          setUploadComputerData={setUploadComputerData}
        />
      )}
    </>
  );
};

export default CustomQuickActionRun;
